module.exports = "<div style=\"margin-top:120px\">\r\n  <div class=\"card\" style=\"    padding-top: 60px;\r\n    padding-bottom: 60px;\r\n    margin-bottom: 60px;\">\r\n    <div class=\"card-body\" style=\"font-size: 24px;text-align: center;\">\r\n      Page Not Found.\r\n    </div>\r\n  </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/Ajatus WorkSpace/Now Grocery/now-grocery/NowGroceryStoreFront/src/app/components/not-found/not-found.component.html
// module id = ../../../../../src/app/components/not-found/not-found.component.html
// module chunks = main